import { Injectable } from '@angular/core';

declare var window: any;

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  setItem<T>(key: string, item: T): void {
    window.sessionStorage.setItem(key, JSON.stringify(item));
  }

  getItem<T>(key: string): T {
    const stringifiedItem = window.sessionStorage.getItem(key);

    if (!stringifiedItem) {
      return undefined;
    }
    return JSON.parse(stringifiedItem);
  }

  removeItem(key: string): void {
    window.sessionStorage.removeItem(key);
  }
}
